import { render, staticRenderFns } from "./CommunicationTypeUpdate.vue?vue&type=template&id=1f649d42&"
import script from "./CommunicationTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./CommunicationTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports